export interface Chart {
  config: {lines: string[]};
  layout: {x: number; y: number; w: number; h: number};
}

export type ChartAreaOption =
  | 'minmax'
  | 'none'
  | 'samples'
  | 'stddev'
  | 'stderr';

/**
 * Two-sided confidence level for the ungrouped `stderr` band. Without one the
 * band is mean ± SE; with one it is mean ± t·SE, with t from the bin's sample
 * count.
 */
export const CONFIDENCE_LEVEL_OPTIONS = [90, 95, 99] as const;
export type ConfidenceLevel = (typeof CONFIDENCE_LEVEL_OPTIONS)[number];

/**
 * The default key is the primary suffix that we want to use binned data off the API response.
 * It was 'Avg' previously, but it's been set to 'Last' so that we can use a real point off the history data. 'Last' refers to the final point in each bucket. It will generally be synonomous with the max xAxis value
 *
 * NOTE: it should eventually be possible to change this back to "Avg" (or something else entirely) but right now there are a few bits of behavior not fully synced with this.
 */
export const BIN_POINT_TO_USE = 'Last';
